@if (_progressService.visible()) {
    <mat-progress-bar
        color="accent"
        [bufferValue]="_progressService.bufferValue()"
        [mode]="_progressService.mode()"
        [value]="_progressService.value()"
        style="height: 1px; position: absolute; top: 0px; width: 100%; z-index: 100000" />
}
<ng-container *ngComponentOutlet="startupService.contentContainer()" />
